import { createContext } from 'react';

export type NotificationSeverity = 'error' | 'warning' | 'success' | 'info';

export interface NotificationItem {
  message: string;
  severity: NotificationSeverity;
}

export interface NotificationContextValue {
  notify: (n: NotificationItem) => void;
  /** Parse automatiquement ApiError ou Error générique */
  notifyError: (error: unknown) => void;
  notifySuccess: (message: string) => void;
}

export const NotificationContext = createContext<NotificationContextValue | null>(null);
